export default __webpack_public_path__ + "static/media/Queen-Annes-Lace_R3.7c031803.png";